import React, { useEffect, useState } from "react";
import plusIcon from "../../../assets/images/Svg/plusIcon.svg";
import { Modal } from "antd";
import AddChronicCondition from "./AddChronicCondition";
import ChronicConditionService from "../../../Services/ChronicConditionService";
import moment from "moment";
import dayjs from "dayjs";
import AddVaccination from "./AddVaccination";
import MedicalService from "../../../Services/MedicalService";
import { FiPlus } from "react-icons/fi";

function Vaccination(props) {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [vaccinationData, setVaccinationData] = useState([]);

  useEffect(() => {
    patientImmunisation();
  }, [props.selectedPatient.patientId]);

  const patientImmunisation = async () => {
    const payload = {
      patientId: props.selectedPatient.patientId,
      status: 1,
    };
    try {
      const response = await MedicalService.PatientImmunisation(payload);
      setVaccinationData(response.data);
    } catch (e) {
      console.error(e);
    }
  };

  const convertUTCDate = (date, format) => {
    if (!format) {
      const d = new Date();
      date = new Date(
        moment(date, "MM-DD-YYYY").format("MM/DD/YYYY") +
          " " +
          d.getHours() +
          ":" +
          d.getMinutes()
      );
    }
    format = format || "MM/DD/YYYY";
    return moment(new Date(date)).utc().format(format);
  };
  const handleChronicClick = () => {
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
    patientImmunisation();
  };

  return (
    <div>
      {/* <div className="card h-[300px] m-5 border rounded-lg">
        <div className="header h-[15%] bg-secondaryColor flex items-center justify-between  rounded-lg p-2">
          <h1 className="font-bold text-normal text-white ">
            Immunisations
          </h1>
          <img
            src={plusIcon}
            onClick={() => handleChronicClick()}
            className="h-10 w-10 cursor-pointer"
            alt=""
          />
        </div>
        <div className="body h-[70%] overflow-y-auto  bg-brand-lightBg p-2" id="unquie-scroll">
          {vaccinationData.length > 0
            ? vaccinationData.map((user, i) => (
                <div>
                  <div key={i} className="items-center mt-3 font-light text-sm">
                    <div className="font-medium text-black">Immunisation : <span className="font-medium text-gray-500">{user?.description}</span></div>
                    <div className="mt-2">
                      <span className="font-medium text-gray-500">
                      Onset date :
                      {dayjs(user.givenDate).format('YYYY-MM-DD')}
                      </span>
                  
                    </div>
                  </div>
                  <hr className="my-4 border-gray-300" />
                </div>
              ))
            : null}
        </div>
        <div className="footer h-[10%]  bg-secondaryColor rounded-md"></div>
      </div> */}

      <div
        className="bg-white rounded-xl border border-gray-200 shadow-sm w-full"
        id="unquie-scroll"
      >
        <div className="flex justify-between items-center p-3">
          <h3 className="text-sm font-bold text-gray-700">Immunisations</h3>
          <div className="flex items-center gap-2 text-blue-500 font-sans font-medium underline text-xs cursor-pointer">
            <div
              onClick={() => handleChronicClick()}
              className="w-6 h-6 rounded-full flex items-center justify-center bg-primaryColor"
            >
              <FiPlus className="text-white w-4 h-4" />
            </div>
            {/* <HiPlusCircle className="text-primaryColor w-7 h-7"/> */}
          </div>
        </div>
        <hr />
        <div className="h-44 p-3 overflow-y-scroll flex flex-col gap-3 scrollWidth">
          {vaccinationData.length > 0 ? (
            vaccinationData.map((user, i) => (
              <div className="relative">
                <div className="overflow-y-scroll pr-2 scrollWidth flex flex-col gap-2">
                  <div className="bg-[#FFFAF6] border border-[#FECE9A]  border-l-4 rounded-lg p-3 text-xs text-gray-700 flex flex-col gap-2">
                    <p>
                      <strong>Immunisation: </strong>
                      {user?.description}
                    </p>
                    <p>
                      Onset Date : {dayjs(user?.givenDate).format("YYYY-MM-DD")}
                    </p>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div></div>
          )}
        </div>
      </div>

      {isModalVisible && (
        <Modal
          title={
            <span className="text-base font-bold font-sans">
              Add Immunisation history
            </span>
          }
          visible={isModalVisible}
          onOk={() => handleCloseModal()}
          centered={true}
          footer={null}
          onCancel={() => handleCloseModal()}
          okText="Submit"
          cancelText="Cancel"
          width={500}
          maskClosable={false}
        >
          <AddVaccination
            selectedPatient={props.selectedPatient}
            onClose={() => handleCloseModal()}
          />
        </Modal>
      )}
    </div>
  );
}

export default Vaccination;
